<template>
    <div class="flex flex-grow justify-end basis-1/4">
        <nav
            class="h-full text-gray" :aria-label="$t('Secondary navigation')"
            :class="{ 'text-white': isImpersonating }"
        >
            <ul class="flex gap-2 h-full at1024:justify-end">
                <Login v-if="!user" />
                <Account v-if="user" />
                <Register v-if="!user" />
                <Cart v-if="user" />
                <NavbarSearch />
            </ul>
        </nav>
    </div>
</template>

<script setup>
import {useCart, useUser} from "@/Composables";
import {Account, Cart, Login, NavbarSearch, Register} from "@/Components";
import { computed } from "vue";
import { usePage } from "@inertiajs/vue3";

const isImpersonating = computed(() => usePage().props.impersonating);

const { cartItemCount } = useCart();
const { user } = useUser();
</script>
